/*
 * SellerReply_v1 propTypes
 */

import { string } from 'prop-types'

export const SellerReply_v1 = {
  comment: string.isRequired,
  date: string.isRequired,
  type: string.isRequired,
}
